import { useContext } from "react";
import usePluginEntities from "hooks/usePluginEntities";
import WidgetActionsContext from "views/components/contexts/WidgetActionsContext";
const useWidgetActions = () => {
  const providedActions = useContext(WidgetActionsContext);
  const pluginWidgetActions = usePluginEntities("views.widgets.actions");
  return providedActions != null ? providedActions : pluginWidgetActions;
};
export default useWidgetActions;
